#@export Modules.SortToggle.Views.SortToggle

Backbone = window?.Backbone ? require 'backbone'

class SortToggleView extends Backbone.View
  events:
    'change': '_onChange'

  _onChange: ->
    @trigger 'change:value', sort: @$el.val()

if module?.exports
  module.exports = SortToggleView
else
  Modules.SortToggle.Views.SortToggle = SortToggleView
